import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import * as lodash from 'lodash-es';
import { Observable, of, ReplaySubject } from 'rxjs';
import { OUService } from '../../modules/admin/ou/ou.service';
import { FuseNavigationItem } from '../../../@fuse/components/navigation/navigation.types';
import { Navigation } from './navigation.types';

@Injectable({providedIn: 'root'})
export class NavigationService {

    private ouService = inject(OUService);
    private transloco = inject(TranslocoService);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private role = this.ouService.role;

    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    get(): Observable<Navigation> {
        const navigation = this.generateNavigation();
        this._navigation.next(navigation);
        return of(navigation);
    }

    private generateNavigation(): Navigation {
        const compactNavigation: FuseNavigationItem[] = [];
        const defaultNavigation: FuseNavigationItem[] = [];
        const futuristicNavigation: FuseNavigationItem[] = [];
        const horizontalNavigation: FuseNavigationItem[] = [];

        if (this.role()?.adminMeAndChildren) {
            const compactAdmin: FuseNavigationItem = {
                id: 'admin',
                title: this.transloco.translate('administration'),
                tooltip: this.transloco.translate('administration'),
                type: 'aside',
                icon: 'mat_outline:admin_panel_settings',
                children: [
                    {
                        id: 'grupoconstant',
                        title: 'GrupoConstant',
                        type: 'basic',
                        icon: 'mat_outline:workspaces',
                        link: '/ou'
                    }
                ]
            };
            compactNavigation.push(compactAdmin);
            
            const commonAdmin: FuseNavigationItem = {
                id: 'admin',
                title: this.transloco.translate('administration'),
                type: 'collapsable',
                icon: 'mat_outline:admin_panel_settings',
                children: [
                    {
                        id: 'grupoconstant',
                        title: 'GrupoConstant',
                        type: 'basic',
                        icon: 'mat_outline:workspaces',
                        link: '/ou'
                    }
                ]
            };
            defaultNavigation.push(commonAdmin);
            futuristicNavigation.push(commonAdmin);
            horizontalNavigation.push(commonAdmin);
        }
        const common: FuseNavigationItem[] = [{
            id: 'endpoints',
            title: this.transloco.translate('endpoints'),
            type: 'basic',
            icon: 'heroicons_outline:list-bullet',
            link: '/endpoints'
        }];

        const compact: FuseNavigationItem[] = [{
            id: 'endpoints',
            title: this.transloco.translate('endpoints'),
            tooltip: this.transloco.translate('endpoints'),
            type: 'basic',
            icon: 'heroicons_outline:list-bullet',
            link: '/endpoints'
        }];
        compactNavigation.push(...compact);
        defaultNavigation.push(...common);
        futuristicNavigation.push(...common);
        horizontalNavigation.push(...common);

        return {
            compact: lodash.cloneDeep(compactNavigation),
            default: lodash.cloneDeep(defaultNavigation),
            futuristic: lodash.cloneDeep(futuristicNavigation),
            horizontal: lodash.cloneDeep(horizontalNavigation),
        };
    }
}
